import { useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { usePopperoDrawero } from "@pinkyhead/dovekit";
import parsePhoneNumber from 'libphonenumber-js'
import { useAuth } from "../../../../../context/auth";
import { useDetails } from "../../../../../context/details";
import { useMap } from "../../../../../context/map";
import { useRoot } from "../../../../../context/root";
import { createFakeSrcSetObject } from "../../../../../utils";
import { ClaimType } from "../../../../../types";
import { pickParticipationLabel } from "./utils";

export const useBasic = () => {
  const navigatorRouter = useNavigate();
  const location = useLocation();
  const { geohash, id } = useParams();
  const searchParams = new URLSearchParams(location.search);
  const { data, isDataLoading, detailsDispatch } = useDetails();
  const {
    drawerOpen,
    drawerShow,
    popperOpen,
    toggleDrawerOpen,
    togglePopperOpen
  } = usePopperoDrawero();
  const inputRef = useRef<any>(null);
  const [isCopied, setIsCopied] = useState(false);
  const { rootDispatch } = useRoot();
  const { mapContext } = useMap();
  const { user } = useAuth();

  const goBack = () => {
    rootDispatch({
      type: "setExtraMarker",
      data: null,
      mapContext
    })
    if (geohash) {
      navigatorRouter({
        pathname: `${process.env.REACT_APP_INTERNAL_URL}bucket/${geohash}`,
        search: searchParams.toString()
      })
    }
    else {
      navigatorRouter({
        pathname: `${process.env.REACT_APP_INTERNAL_URL}`,
        search: searchParams.toString()
      })
    }
  }

  const handleChangeTab = (id: number) => {
    detailsDispatch({
      type: "setActiveTab",
      data: {
        id: id,
        name: ""
      }
    })
  }

  const redirectToCoreProfile = (url: string | undefined) => {
    if (url) {
      window.open(`${window.location.origin}${url}`, "_blank")
    }
  }

  const redirectToClaim = (data: any) => {
    const itemType = data.itemType.toLocaleLowerCase();
    const id = data.id.slice(1, data.id.length);
    const nextUrl = searchParams.get("next") || "";

    if (itemType === "other healthcare") {
      return window.location.href = `/dovemed-sso/claim/ohcp/match-found/id/${id}?next=${nextUrl}`
    }
    return window.location.href = `/dovemed-sso/claim/${itemType}/claim/${id}?next=${nextUrl}`
  }

  const copyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
    if (inputRef.current) {
      inputRef.current.select();
      document.execCommand('copy');
    }
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false)
    }, 2000)
  }

  const redirectToLoginPage = () => {
    window.location.href = ("/dovemed-sso/?next=" + window.location.href);
  }

  const formatPhoneNumber = (phoneNumber: string) => {
    const number = parsePhoneNumber(phoneNumber, "US");
    if (number) {
      const formatedNumber = number.formatNational();
      if (formatedNumber) {
        return formatedNumber;
      }
      return number.number;
    }
    return phoneNumber;
  }

  return {
    data: {
      ...data,
      picture: createFakeSrcSetObject(data?.picture || null),
      phoneNumber: formatPhoneNumber(data?.phoneNumber || ""),
      itemTypeLowerCase: data?.itemType ? data.itemType.toLowerCase() : '',
    },
    isDataLoading,
    goBack,
    handleChangeTab,
    drawerOpen,
    drawerShow,
    popperOpen,
    toggleDrawerOpen,
    togglePopperOpen,
    redirectToCoreProfile,
    participationLabel: pickParticipationLabel(data?.itemType),
    inputRef,
    url: window.location.href,
    copyToClipboard,
    isCopied,
    user,
    redirectToLoginPage,
    redirectToClaim,
    showClaimButton: !!searchParams.get("claim") && (
      (searchParams.get("item_type") === ClaimType.Hospital) ||
      (searchParams.get("item_type") === ClaimType.Clinic) ||
      (searchParams.get("item_type") === ClaimType.NFP) ||
      (searchParams.get("item_type") === ClaimType.OHCP))
  }
}
